import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ROUTE_PATH,
  APPLICATION_MODE_NEW,
  LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION,
  APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE,
} from "../../app/constants";
import { fullName } from "../../app/utils";
import { push } from "connected-react-router";
import {
  Header,
  Button,
  Paragraph,
  ErrorMark,
} from "../../components/RegularComponents";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import { ERROR_STRING } from "../../app/errors";
import { setAgencyBusinessContact, setMortgageProperty } from "../../redux/slice/primaryAgencyApplicationSlice";
import TopNavigationBar from "../TopNavigationBar";
import { applicationTypeFromLicenceSubType } from '../../redux/slice/applicationsUtils';

export const SelectLender = (props) => {
  // const applicationType = APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE;
  const applicationMode = APPLICATION_MODE_NEW;

  const { isModal = false, onEditSave = () => {} } = props;
  const [showError,setShowError] = useState(false);
  const [errorString, setErrorString] = useState(null);

  const { licencingSubType } = useSelector((state) => ({
    licencingSubType : state.primaryAgencyApplication.application?.licencingSubType ?? LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION,
  }));

  const applicationType = applicationTypeFromLicenceSubType(licencingSubType);

  const {
    mainBusinessContact, 
    complianceOfficer, 
    companyRjscDetails,
    personData
  } = useSelector(
    (state) =>
    {
      return {
        mainBusinessContact : state.primaryAgencyApplication?.application?.businessLicenceData?.mainBusinessContact,
        complianceOfficer : state.primaryAgencyApplication?.application?.businessLicenceData?.complianceOfficer,
        companyRjscDetails : state.primaryAgencyApplication?.application?.businessLicenceData?.companyRjscDetails,
        personData : state.primaryAgencyApplication?.application?.businessLicenceData?.personData
      }
    }
  );

  const dispatch = useDispatch();
  const [applicationSaveError, setApplicationSaveError] = useState(false);

  const [selectedComplianceOfficerEntityId, setSelectedComplianceOfficerEntityId] =
    useState(null);

  const peopleList = companyRjscDetails?.businessData?.peopleList ?? []

  const nameListComponent = () => {
    const nameList = [];

    peopleList.forEach((people) => {
      const { entityId } = people;
      nameList.push(
        <div
          key={entityId}
          className="ns-radios__item"
          style={{ marginBottom: "1.5em" }}
        >
          <input
            className="ns-radios__input"
            key={entityId + "-input"}
            type={"radio"}
            value={entityId}
            checked={entityId === selectedComplianceOfficerEntityId}
            onChange={(e) => setSelectedComplianceOfficerEntityId(e.target.value)}
            id={"select-compliance-officer-people-list-" + entityId + "-input"}
            name={"select-compliance-officer-people-list-" + entityId + "-input"}
          />
          <label
            key={entityId + "-label"}
            id={"select-compliance-officer-people-list-" + entityId + "-label"}
            className="ns-radios__label"
            htmlFor={
              "select-compliance-officer-people-list-" + entityId + "-input"
            }
          >
            <span className="ns-label-span">
              {`${fullName(people)}, ${people.position}`}
            </span>
          </label>
        </div>
      );
    });

    return (
      <fieldset className="ns-fieldset">
        <div className={"ns-radios"}>{nameList}</div>
      </fieldset>
    );
  };

  const handleSave = () => {
    const selectedPerson = peopleList.filter(
      (p) => p.entityId === selectedComplianceOfficerEntityId
    );

    if (!selectedPerson?.length) {
      setShowError(true)
      setErrorString(ERROR_STRING.SELECT_AT_LEAST_ONE_OFFICER)
      return false
    }
    
    setShowError(false)
    setErrorString(null)

    const person = selectedPerson[0]

    dispatch(
      setAgencyBusinessContact({
        mainBusinessContact: {
          ...mainBusinessContact,
          firstName: person.firstName,
          lastName: person.lastName,
        },
        complianceOfficer : {
          ...complianceOfficer,
          firstName: person.firstName,
          lastName: person.lastName,
        }
      })
    )

    dispatch(setMortgageProperty({
      key : "personData",
      value : {
        ...personData,
        firstName : person.firstName,
        lastName : person.lastName,
        rjscEntityId: person.entityId
      }
    }))

    return true
  }

  const handleSaveNext = () => {
    if(handleSave()) {
      dispatch(saveBusinessLicenceApplicationData(
        applicationType, applicationMode)).then(values => {
          const nextRoutePath = (applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE) ? ROUTE_PATH.ML_APP : ROUTE_PATH.MA_APP
          // application saved, go to the next page.
          dispatch(
            push(
              `${nextRoutePath}${ROUTE_PATH.ML_LENDER_CONTACT_INFORMATION}`
            )
          );
        })
        .catch(error => {
          setApplicationSaveError(true);
        });
    }
  };

  const handleSaveandClose = () => {
    if (handleSave()) {
      onEditSave();
    }
  };

  return (
    <>
      <div className={!isModal ? "container" : ""}>
        {!isModal && (
          <>
            <TopNavigationBar {...props} 
                applicationType={applicationType} 
                applicationMode={APPLICATION_MODE_NEW}
            />
            <div className="row">
              <div className="col-lg-8">
                <Header
                  id="select-compliance-officer-header"
                  header="Compliance Officer"
                />
              </div>
            </div>
          </>
        )}

        <div className="row">
          <div className="col-lg-8">
            <Paragraph
              id="select-compliance-officer-text"
              text={["Select your name from the list"]}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-8">{nameListComponent()}</div>
        </div>

        <div className="row">
          <div
            className={"col-lg-2" + ((applicationSaveError || showError) ? " has-error" : "")}
          >
            <Button
              id="select-compliance-officer-save-next-button"
              buttonType="regular_primary"
              text={!isModal ? "Save and next" : "Save and close"}
              onClick={!isModal ? handleSaveNext : handleSaveandClose}
            />
            {(applicationSaveError || showError) && ErrorMark()}
            {applicationSaveError && (
              <div className="ns-error-message help-block topMarginNormal">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )}
            {showError && (
              <div className="ns-error-message help-block topMarginNormal">
                <span className="ns-visually-hidden">Error:</span>
                {errorString}
              </div>
            )}
          </div>
          {/* <div className="col-lg-4">
            <NavigationLinkButton
              id="select-pricipal-broker-no-name-button"
              text="My name isn't on this list"
              onClick={() => {
                // window.location.assign(RJSC_PAGE_LINK)
                window.open(RJSC_PAGE_LINK, '_blank');
              }}
            />
          </div> */}
        </div>
      </div>
    </>
  );
};
